<template lang="pug">
v-container.form-actions.pa-0(fluid)
  v-layout.pa-2(
    wrap
    align-center
    justify-center)
    .body-1.error--text(xs12)
      slot
  v-layout(
    wrap
    align-center
    justify-space-between)
    v-flex.pa-2(
      xs6
      sm5)
      v-btn(
        :loading="loading"
        flat
        outline
        color="error"
        @click="$emit('cancel')") {{ cancelText }}
    v-flex.text-xs-right.pa-2(
      xs6
      sm5)
      v-btn(
        :loading="loading"
        flat
        outline
        color="indigo"
        @click="$emit('submit')") {{ submitText }}
</template>
<script>
export default {
  name: "FormActions",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: [String, Number],
      default: "取消"
    },
    submitText: {
      type: [String, Number],
      default: "送出"
    }
  }
};
</script>
